import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { avgViewsPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import BubbleCommon, { avgViewsFilterTips } from '@op/components/BubbleCommon';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
export default function AvgViewsSelect({
  onChange,
  defaultValue,
  filterValue,
  oriDefaultFilter,
  backOriDefaultValue,
  defaultKey,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();

  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      oriDefaultFilter,
      backOriDefaultValue,
      defaultKey: 'avg_views',
      subDefaultKey: 'view',
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 50K', value: '0-50' },
        { text: '50K ~ 100K', value: '50-100' },
        { text: '100K ~ 500K', value: '100-500' },
        { text: '500K ~ 1M', value: '500-1000' },
        { text: '1M+', value: '1000-' },
      ],
    });

  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      let dataItem: { start_view: number; end_view?: number } = {
        start_view: Number(start) * 1000,
      };
      if (end !== '') {
        dataItem['end_view'] = Number(end) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.(
      'avgViews',
      commonBackInfo({ avg_views: data }, { avgViews: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  return (
    <BubbleCommon placement="top" showIcon={false} tipsMap={avgViewsFilterTips}>
      <div className={`dbo-avg-views-wrapper ${diffClassName}`}>
        <CustomFollowerRange
          lang={lang}
          ref={followerRef}
          options={options}
          setRangeValue={setRangeValue}
          rangeValue={rangeValue}
          placeholder={avgViewsPlaceholder}
          pointKey={FilterButtonPoint.avgViews}
        ></CustomFollowerRange>
      </div>
    </BubbleCommon>
  );
}
